import styled from 'styled-components';

import ActionButton from '@formstack/phoenix/components/Button/ActionButton';
import { Modal } from '@formstack/phoenix/components/Modal/Modal';
import { ModalContent } from '@formstack/phoenix/components/Modal/ModalContent';
import { ModalFooter } from '@formstack/phoenix/components/Modal/ModalFooter';
import { ModalHeader } from '@formstack/phoenix/components/Modal/ModalHeader';
import { ModalSizeVariants } from '@formstack/phoenix/components/Modal/constants';
import { ElementSizeVariants } from '@formstack/phoenix/components/componentSizeVariants/constants';

import { IErrorDialog } from './interface';

const StyledActionButton = styled(ActionButton)`
  margin-left: auto;
` as any;

const ErrorDialog = ({ open, error: { description, message }, onClose }: IErrorDialog) => (
  <Modal open={open} size={ModalSizeVariants.small} closeAction={onClose}>
    <ModalHeader>{description}</ModalHeader>

    <ModalContent>{message}</ModalContent>

    <ModalFooter>
      <StyledActionButton
        id="errorDialogAcknowledgement"
        action={onClose}
        buttonText="Ok"
        buttonSize={ElementSizeVariants.small}
        variant="edit-light"
      />
    </ModalFooter>
  </Modal>
);

export { ErrorDialog };
